
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/community",
      function () {
        return require("private-next-pages/--roboneo/community/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/community"])
      });
    }
  